import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import Grid from '@material-ui/core/Grid';

import { useStyles } from './../UserTheme';

// match form
import MatchHits from "./MatchHits";

// GET - POST 
import useAxios from "../../../request/useAxios";

import FoldingFrame from "../../FoldingFrame/FoldingFrame";

export default function MatchContainer() {

  const [items, setItems] = useState({});
  // match id
  const params = useParams();
  // stílus
  const classes = useStyles();

  const { get } = useAxios();
  useEffect(() => {

    // load user match
    const TS = JSON.parse(localStorage.getItem("TS"));
    get(`/personality/get-all-matching-position/${TS.userId}`,
      {
        headers: {
          Authorization: `Bearer ${TS.token}`,
        },
      })
      .then((data) => {
        setItems(data);
        // console.log("Match data: ", data);
      })
      .catch((error) => console.log("Could not load user", error));
  }, []);

  return <Grid container direction="row" className={classes.root}>
    <FoldingFrame open={params.id ? false : true}>
      <Grid item className={classes.formContanier} id="collapseForm">
      </Grid>
    </FoldingFrame>
    <Grid item xs >
      <Grid container className={classes.grund} >
        {params.id && <MatchHits items={items} />}
      </Grid>
    </Grid>
  </Grid >;
}